import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48e337e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claimInfo" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ")", -1 /* HOISTED */))
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.percentageVale)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString($setup.props.header) + " (", 1 /* TEXT */),
          _createVNode($setup["PercentsView"], {
            amount: $props.percentageVale,
            precision: 2
          }, null, 8 /* PROPS */, ["amount"]),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.props.header), 1 /* TEXT */)),
    _renderSlot(_ctx.$slots, "default", { class: "claimInfo__slot" }, undefined, true)
  ]))
}